import React from 'react';
import NextLink from 'next/link';

import { Accent } from '@nerdwallet/currency/components/Accent';
import { Cluster } from '@nerdwallet/currency/components/Cluster';
import { Link } from '@nerdwallet/currency/components/Link';
import { Text } from '@nerdwallet/currency/components/Text';
// IconProps are *uniform* across all icons in @nerdwallet/react-icon,
// but IconProps aren't generically exported. So, import a random icon
// just so can we use its IconProps.
import { IconProps } from '@nerdwallet/react-icon/nerdwallet-ui/Add';

type IconTextLinkProps = {
  href?: string;
  icon: React.FC<IconProps>;
  iconSize?: number;
  label?: string;
  onClick?: () => void;
  small?: boolean;
};

/**
 * This component renders a <Link> that looks good with an Icon (from @nerdwallet/react-icon):
 *   - Icon is aligned correctly
 *   - Avoids unsightly hover underline below icon
 */
const IconTextLink = ({
  href,
  icon: Icon,
  iconSize,
  label,
  onClick,
  small,
}: IconTextLinkProps) => (
  <Link component={href ? NextLink : undefined} href={href} onClick={onClick}>
    <Cluster spacing={1} alignY="center">
      <Icon size={iconSize} textAligned />
      {small ? <Accent size="small">{label}</Accent> : <Text>{label}</Text>}
    </Cluster>
  </Link>
);

export default IconTextLink;
